export default __webpack_public_path__ + "generic_error.a937673.svg";